import React, { Component } from 'react';
import logo from './logo.svg';
import './App.css';

class App extends Component {

  constructor(props) {
    super(props);
  
    this.state = {user: '', pass: '', token: '', isAdmin: '',showLogin: true, showState: false, tagresp: {}, currentState:{}, showTags:false,};
  }


  getTags = () => {
    const {token, } = this.state;
   fetch('https://dev.spots2.com/spots/getInactiveTags/' + token , {
    method: 'GET',
    headers: {
      'Accept':'application/json'
    }
   }).then((response) => response.json())
     .then((responseJson) => {
      if(!responseJson.code) {
       this.setState({tagresp: responseJson, showTags:true})
       }else {
        alert("error getting tags " + responseJson.code );
       }
      })
      .catch((error) => {
        alert('could not get tags');
      });

  }

  handleSubmit = (e) => {
      
      const {user,pass} = this.state;
      e.preventDefault();

      fetch('https://dev.spots2.com/spots/user/loginadmin',{
      method: 'POST',
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
  body: JSON.stringify({
    email: user,
    password: pass,
  })
})
      .then((response) => response.json())
      .then((responseJson) => {
        if(responseJson.code) {
          alert('not admin dude');
        }else if(responseJson.token) {
          this.setState({showLogin: false, token: responseJson.token});

      }
      })
      .catch((error) => {
        alert('not admin dude');
      });
  }

  user = (e,text) => {
    e.preventDefault();
    this.setState({user: e.target.value });
  }

  doApprove =(e,name) => {
    const {token, } = this.state;
    e.preventDefault();
    fetch('https://dev.spots2.com/spots/activateTag/' + name + '/' + token,{
      method: 'PUT',
  headers: {
    'Accept': 'application/json',
  }
}).then((response) => {
        if(response.status === 201) {
          this.getTags();
        }else {
          alert('Ooops issue adding tag');
        }

      })
      .catch((error) => {
        alert('Ooops error adding tag');
      });
  }

  doDelete =(e,name) => {
    const {token, } = this.state;
    e.preventDefault();
    fetch('https://dev.spots2.com/spots/deleteTag/' + token + '/' + name,{
      method: 'DELETE',
      headers: {
    'Accept': 'application/json',
  }
}).then((response) => response.json())
      .then((responseJson) => {
        if(responseJson.code) {
          alert('Ooops issue adding tag');
        }else {
          this.getTags();
        }

      })
      .catch((error) => {
        alert('Ooops issue adding tag');
      });
  }

  pass = (e,text) => {
    e.preventDefault();
    this.setState({pass: e.target.value});
  }

  stateView = () => {
    const {currentState, } = this.state;

    return(
        <div style={{ alignSelf: 'center', padding:5, backgroundColor:'blue', color: 'white', marginBotton:50}}>
            <b>Users : </b> {currentState.users} <b> Tags: </b> {currentState.tags}
        </div>
      );
  }

  doState = () => {


    const {token,} = this.state;

    fetch('https://dev.spots2.com/spots//currentState/' + token , {
    method: 'GET',
    headers: {
      'Accept':'application/json'
    }
   }).then((response) => response.json())
     .then((responseJson) => {
      if(!responseJson.code) {
       this.setState({currentState: responseJson, showState: true})
       }else {
        alert("error getting state " + responseJson.code );
       }
      }).catch((error) => {
        alert('could not get tags');
      });
  }

  loginView = () => {
    const {user, pass,} = this.state;

    return (
        <div style ={{ marginLeft:20, marginTop:50,alignSelf:'center'}}>
        <form onSubmit={this.handleSubmit} >
          User:<input type ="text" value={user} style={{marginLeft:5}} onChange = { (e,text) => this.user(e,text)}/><br/>
          Pass:<input type ="pass" value={pass} style={{marginLeft:5}}  onChange = { (e,text) => this.pass(e,text)}/><br/>
          <input type="submit" value="Submit" />
          </form>
        </div>
      );
  }

  tagView = () => {
      const {tagresp,token} = this.state;
    return (
      <div style={{alignSelf: 'center' }}>
        <table  style={{border:'1px solid black'}} cellpadding='3' cellspacing='2' >
          <tr style={{backgroundColor:'yellow'}}>
            <th >image</th><th>user</th><th>name</th><th>description</th><th></th><th></th>
          </tr>
          {tagresp.tags.map( tag => <tr><td><img style={{width:100, height:100}} src={`https://dev.spots2.com/spots/getImage/${tag.imageName}`} /></td><td>{tag.email}</td><td>{tag.name}</td><td>{tag.description}</td><td style={{padding:'5px',backgroundColor:'green',color:'white'}} onClick={(e) => this.doApprove(e,tag.name)}>approve</td><td style={{padding:'5px',backgroundColor:'red',color:'white' }} onClick={ (e) =>  {if (window.confirm('Are you sure you wish to delete this tag?')) this.doDelete(e,tag.name) }}>delete</td></tr>)}
        </table>
      </div>
    );
  }


  render() {
    const {showLogin,showState,showTags} = this.state; 
    return (
      <div style={{display:'flex', flex:1, flexDirection: 'column'}}>
     {showLogin && this.loginView() }
     {!showLogin && !showState &&  this.doState()}
     {showState &&  this.stateView()}
     {!showLogin && !showTags && this.getTags()}
     {showTags && this.tagView()}
     </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js